<h4 mat-dialog-title>{{ dialogTitle }}</h4>
<mat-dialog-content class="dialog">
  <div class="mat-typography">
    @if(searchToggleFG.get('searchToggle')?.value){
    <app-user-search
      [singleSelect]="singleSelect"
      [selectedRows]="selectedRowsUsers"
      [selectedRowsGroups]="selectedRowsGroups"
      (filterValueEmitter)="updateRows($event)" />
    }
  </div>
  <mat-dialog-actions align="end">
    <!-- <button mat-stroked-button (click)="savePeople()" [disabled]="applyDisabled()">{{'btn.apply'|translate}}</button> -->
    <!-- INFO: no apply disabled since it should probably be possible to unselect entire selections of people..? -->
    <button
      mat-stroked-button
      (click)="savePeople()">
      Save
    </button>
    <button
      mat-stroked-button
      mat-dialog-close>
      Cancel
    </button>
  </mat-dialog-actions>
</mat-dialog-content>
